import type { SprintParticipant, SprintTeam } from '../types/Sprint'

/** One team's display row for training sprint / upcoming activity UIs. */
export type SprintTeamDisplayDetail = {
  teamName: string
  memberNames: string[]
}

/**
 * Groups sprint participants by team for facilitator sprint cards and gamer upcoming activities.
 * Mirrors the logic previously inlined in transition-web-evolve `sprints.ts` getTrainingSprints.
 */
export function buildSprintTeamDisplayBuckets(input: { teams: SprintTeam[]; participants: SprintParticipant[] }): {
  teamDetails: SprintTeamDisplayDetail[]
  unassignedMemberNames: string[]
} {
  const teams = input.teams ?? []
  const participants = input.participants ?? []
  const assignedTeamIds = new Set(teams.map((t) => t.tempTeamId))

  const teamDetails = teams.map((team) => ({
    teamName: team.name,
    memberNames: participants.filter((p) => p.teamId === team.tempTeamId).map((p) => p.name)
  }))

  const unassignedMemberNames = participants
    .filter((p) => !p.teamId || !assignedTeamIds.has(p.teamId))
    .map((p) => p.name)

  return { teamDetails, unassignedMemberNames }
}
